module.exports = __webpack_public_path__ + "img/lang-2.8966ca3c.jpg";